import React from "react"
import withStyles from "react-jss"
import { AnswerButton } from "."
import colors from "../data/colors"
import { FADEIN, FADEOUT, DURATION } from "../data/globalStyles"
import { gourds } from "../assets/images"

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    width: "80%",
    maxWidth: "1000px",
    marginTop: "70px",
    height: "100%",
    animation: ({ data }) =>
      `${
        data[0].showQuestion ? `$${FADEIN}` : `$${FADEOUT}`
      } ${DURATION} ease-in-out`,
  },
  heading: {
    color: colors.black,
    padding: "0 1rem",
    textAlign: "center",
    marginBottom: "1rem",
    fontSize: "calc(16px + (26 - 16) * ((100vw - 300px) / (1600 - 300)))",
  },
  line: {
    width: "30px",
    border: `1px solid ${colors.orange}`,
    margin: "0 0 1.5rem 0",
  },
  loadingLine: {
    composes: "$line",
    margin: "0 0 2px 0",
  },
  grid: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    flexWrap: "wrap",
    // To keep the container more top-center aligned
    marginBottom: "5rem",
  },
  loadingGrid: {
    composes: "$grid",
    // To keep the container more top-center aligned,
    // while accomodating the huge loading GIF
    marginBottom: "4rem",
  },
  row: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "row",
    flexWrap: "wrap",
    width: "100%",
    "@media only screen and (max-width: 810px)": {
      justifyContent: "center",
      alignItems: "center",
    },
  },
  imageContainer: {
    composes: "$row",
    justifyContent: "center",
    alignItems: "center",
  },
  image: {
    width: "60vw",
    minWidth: "300px",
  },
  [`@keyframes ${FADEIN}`]: {
    from: {
      opacity: 0,
    },
    to: {
      opacity: 1,
    },
  },
  [`@keyframes ${FADEOUT}`]: {
    from: {
      opacity: 1,
    },
    to: {
      opacity: 0,
    },
  },
}

const Question = ({ classes, data, onClick, onAnimationEnd }) => {
  const renderOptions = (qId, options) => {
    if (options.length === 4 || options.length === 3) {
      return (
        <>
          <div className={classes.row}>
            {options.slice(0, 2).map((option, i) => (
              <AnswerButton
                key={i}
                id={i}
                text={option.text}
                onClick={() => onClick(qId, option.optionId)}
              />
            ))}
          </div>
          <div className={classes.row}>
            {options.slice(2, 4).map((option, i) => (
              <AnswerButton
                key={i}
                id={i}
                text={option.text}
                onClick={() => onClick(qId, option.optionId)}
              />
            ))}
          </div>
        </>
      )
    }
    // length === 2 || n
    return (
      <div className={classes.row}>
        {options.map((option, i) => (
          <AnswerButton
            id={i}
            text={option.text}
            onClick={() => onClick(qId, option.optionId)}
          />
        ))}
      </div>
    )
  }

  const { qId, text, options, loading } = data[0]

  return (
    <section className={classes.container} onAnimationEnd={onAnimationEnd}>
      <h3 className={classes.heading}>{text}</h3>
      <hr className={loading ? classes.loadingLine : classes.line} />
      <div className={loading ? classes.loadingGrid : classes.grid}>
        {loading ? (
          <div className={classes.imageContainer}>
            <img
              className={classes.image}
              src={gourds}
              alt="Cutomizing your menu..."
            />
          </div>
        ) : (
          renderOptions(qId, options)
        )}
      </div>
    </section>
  )
}

export default withStyles(styles)(Question)
